import React from 'react';
import './GeometricLoader.scss';

interface GeometricLoaderProps {
  message?: string;
  size?: 'small' | 'medium' | 'large';
}

export const GeometricLoader: React.FC<GeometricLoaderProps> = ({ 
  message = "Cargando...", 
  size = 'medium' 
}) => {
  return (
    <div className={`geometric-loader geometric-loader--${size}`}>
      <div className="geometric-loader__container">
        <div className="geometric-loader__shapes">
          <div className="geometric-loader__shape geometric-loader__triangle">
            <div className="triangle"></div>
          </div>
          <div className="geometric-loader__shape geometric-loader__square">
            <div className="square"></div>
          </div>
          <div className="geometric-loader__shape geometric-loader__circle">
            <div className="circle"></div>
          </div>
        </div>
        <div className="geometric-loader__message">
          {message}
        </div>
      </div>
    </div>
  );
};